import {getCountries, getCountryCallingCode} from 'libphonenumber-js'

export function getAllCountriesWithPrefixes(locale: string) {
  const normalizedLocale = locale.replace(/_/g, '-')
  const countries = getCountries()
  return countries.map(countryCode => ({
    name: new Intl.DisplayNames(normalizedLocale, {type: 'region'}).of(countryCode),
    iso2: countryCode,
    dialCode: getCountryCallingCode(countryCode),
    priority: 0,
    areaCodes: null,
  }))
}

/**
 * Returns a localised country name for an ISO 3166-1 alpha-2 code.
 *
 * Resolution order:
 *   1. `i18nLookup('countries.${code}')` if it returns a translated value
 *      (preserves curated entries like `countries.ES = "España"`).
 *   2. `Intl.DisplayNames(locale, {type: 'region'}).of(code)` for any other code.
 *   3. The raw code as a defensive fallback.
 */
export function getCountryLabel(
  code: string | undefined | null,
  locale: string,
  i18nLookup?: (key: string) => string | undefined,
): string {
  if (!code) return ''

  if (i18nLookup) {
    const key = `countries.${code}`
    const translated = i18nLookup(key)
    if (translated && translated !== key) return translated
  }

  try {
    return new Intl.DisplayNames(locale.replace(/_/g, '-'), {type: 'region'}).of(code) ?? code
  } catch {
    return code
  }
}
